import angular from 'angular';

(function() {
    'use strict';

    angular.module('app').component('mockDemoGuidelines', {
        template: require('./mock-demo-guidelines.html'),
        controller: Ctrl,
        controllerAs: 'vm'
    });

    Ctrl.$inject = ['$state', 'SessionService', 'QueryService'];

    function Ctrl($state, SessionService, QueryService) {
        var vm = this;

        vm.booked = false;

        if(SessionService.getUser()){
            QueryService.query({
                method: 'GET',
                route: { my_hiring_schedule: 'mock_demo' }
            }).then(
                function(response) {
                    const data = response.data.data;
                    vm.booked = !!(data && data.start);
                },
                function() {}
            );
        }

        vm.logo = require('Images/logofull3.png');
        vm.qr_student = require('Images/mock-demo/mock-qr-student.png');
        vm.qr_evaluator = require('Images/mock-demo/mock-qr-evaluator.png');

        vm.scroll_to = id => {
            const el = document.getElementById(id);
            if(el){
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        vm.book = () => {
            $state.go(SessionService.getUser() ? 'application-details' : 'login2');
        };
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/mock-demo-guidelines/mock-demo-guidelines.component.js